import { assert } from '../../assert/assert.js'
import { bigNumberify, NumberLike } from '../../math/bigNumber.js'
import { TimestampLike, UnixTimestamp } from './UnixTimestamp.js'

export function timestampLikeToMs(value: TimestampLike): bigint {
  if (UnixTimestamp.isInstance(value)) {
    return value.toMilliseconds()
  }

  if ('milliseconds' in value) {
    return unitToBigInt(value.milliseconds)
  }

  const secondsAsBigInt = unitToBigInt(value.seconds)
  assert(
    secondsAsBigInt <= YEAR_3000_TIMESTAMP_IN_SECONDS,
    'Value should be less than or equal to 3000-01-01T00:00:00.000Z. Probably you passed milliseconds instead of seconds.',
  )
  return secondsAsBigInt * 1000n
}

function unitToBigInt(value: NumberLike): bigint {
  const valueAsBigNumber = bigNumberify(value)
  assert(!valueAsBigNumber.dp(), 'Value should not have decimal points in its representation')

  const result = BigInt(valueAsBigNumber.toFixed())
  assert(result >= 0, 'Value should be greater than or equal to 0')
  return result
}

const YEAR_3000_TIMESTAMP_IN_SECONDS = Math.floor(new Date('3000-01-01T00:00:00.000Z').getTime() / 1000)
